export default __webpack_public_path__ + "static/media/Duitsland.672cc0a7.svg";